<div style="height: 100%;">
    <p style="color: white; float:right">Esc to Escape</p>
    <p *ngIf="subtitle" class="pdf-dialog__subtitle">{{ subtitle }}</p>
    <br>
    <object *ngIf="hasPdf; else emptyState" id="pdf-viewer" [data]="pdfUrl | sanitizeHtml:'resourceUrl'"
        type="application/pdf" width="100%" height="100%"></object>
    <ng-template #emptyState>
        <div class="pdf-dialog__empty">
            <mat-icon class="pdf-dialog__empty-icon">description</mat-icon>
            <p class="pdf-dialog__empty-text">{{ message }}</p>
        </div>
    </ng-template>
</div>
